import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Calendar, ExternalLink } from "lucide-react";
import { openCalendly } from "@/lib/calendly";

interface ScheduleDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ScheduleDialog = ({ open, onOpenChange }: ScheduleDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-[calc(100vw-2rem)] max-w-md border-0 p-0 bg-transparent shadow-none [&>button]:text-white [&>button]:hover:text-white/80"
      >
        <div
          className="rounded-2xl sm:rounded-3xl px-5 py-8 sm:px-8 sm:py-10 space-y-5 sm:space-y-6"
          style={{
            background: 'rgba(255, 255, 255, 0.12)',
            backdropFilter: 'blur(28px) saturate(1.5)',
            WebkitBackdropFilter: 'blur(28px) saturate(1.5)',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            boxShadow:
              '0 8px 32px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255,255,255,0.3)',
          }}
        >
          {/* Icon */}
          <div className="flex justify-center">
            <div
              className="w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center"
              style={{ background: 'var(--gradient-green)' }}
            >
              <Calendar className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
            </div>
          </div>

          <DialogTitle className="text-xl sm:text-2xl font-typewriter font-bold text-white text-center">
            Agende sua consulta
          </DialogTitle>

          <p className="text-white/80 text-center text-xs sm:text-sm leading-relaxed font-sans">
            Escolha o melhor horário diretamente na minha agenda online. A consulta inicial dura cerca de 30 minutos.
          </p>

          {/* Calendly CTA */}
          <Button
            size="lg"
            className="w-full rounded-full text-base sm:text-lg py-5 sm:py-6 bg-white text-foreground hover:bg-white/90 font-semibold shadow-lg"
            onClick={() => {
              onOpenChange(false);
              openCalendly();
            }}
          >
            <ExternalLink className="mr-2 h-5 w-5" />
            Ver horários disponíveis
          </Button>

          <div className="flex items-center gap-3">
            <div className="flex-1 h-px bg-white/20" />
            <span className="text-white/50 text-xs font-sans">ou mande uma mensagem</span>
            <div className="flex-1 h-px bg-white/20" />
          </div>

          {/* WhatsApp alternative */}
          <Button
            size="lg"
            className="w-full rounded-full text-base sm:text-lg py-5 sm:py-6 font-semibold border-0"
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(12px)',
              color: 'white',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.28)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
            }}
            onClick={() => window.open('https://wa.me/61423038977', '_blank')}
          >
            Falar no WhatsApp
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleDialog;
